import { Link } from 'react-router-dom';

import './NotFoundPage.css';

function NotFoundPage() {
  return (
    <section className="not-found">
      <p className="not-found__code">404</p>
      <h1 className="not-found__title">Page not found</h1>
      <p className="not-found__text">
        The page you requested does not exist or has been moved.
      </p>
      <Link className="not-found__link" to="/">
        Return home
      </Link>
    </section>
  );
}

export default NotFoundPage;
